import React, { useState, useMemo, useEffect } from 'react';
import Pagination from '@components/Layout/Pagination';
import SearchBar from '@components/Layout/SearchBar';
import UserTable from '@components/Layout/UserTable';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';
import { FaFilter } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import {
    CREATE_HOSPITAL_USER_PATH,
    INDIVIDUAL_USER_PATH,
    HOSPITAL_USER_PATH,
    NURSE_USER_PATH,
} from '@constants/routes';
import CloseIcon from '@components/SvgComponents/CloseIcon';
import { ADD_USER_NURSWE_SRC, ADD_USER_HOSPITAL_SRC } from '@constants/images';
import { HOSPITAL, NURSE } from '@constants/constants';
import { useDispatch } from 'react-redux';
import {
    setAdminCreateNurse,
    setShowUpdatePassword,
    setUserRole,
    setDeviceUniqueID,
    setHospitalName,
    setHospitalBranch,
    setHospitalID,
    setAddressOne,
    setAddressTwo,
    setCity,
    setUserState,
    setCountry,
    setPincode,
    setHospitalWebsite,
    setHospitalEmail,
    setHospitalContact,
    setHospitalGST,
    setFileMetadata,
    setName,
    setEmail,
    setMobileNumber,
    setPassword,
    setAdminCreateHospital,
    setCountryList,
    setAdminCreateIndividual,
} from '@store/reducers/auth/signupSlice';
import { fetchCountries, hospitalUserList } from '@utils/utils';
import DataLoader from '@components/DataLoader';
import Swal from 'sweetalert2';

const MySwal = Swal;

const parseDate = (dateString: string): Date => {
    // console.log('date', dateString);
    const [day, month, year] = dateString.split('/').map(Number);
    return new Date(year, month - 1, day); // month is 0-indexed in Date constructor
};

type CustomDropdownToggleProps = {
    children?: React.ReactNode;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const CustomDropdownToggle = React.forwardRef<
    HTMLButtonElement,
    CustomDropdownToggleProps
>(({ children, onClick }, ref) => (
    <button
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick?.(e);
        }}
        className="btn !bg-primary py-2 !text-white"
    >
        {children}
        <FaFilter className="ml-2" /> {/* Add your custom icon here */}
    </button>
));

interface UserData {
    id: string;
    email?: string;
    hospitalEmail?: string;
    name?: string;
    deviceId?: string;
    mobileNo?: string;
    createdAt?: string;
    createdAt_time?: string;
    hospitalName?: string;
    hospitalContact?: string;
    status?: string;
    userEmailStatus?: string;
}

const HospitalUserList = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedChoice, setSelectedChoice] = useState(NURSE);
    const [sortField, setSortField] = useState('newest');
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [filterField, setFilterField] = useState('all');
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [statusFilter, setStatusFilter] = useState('');
    const [userData, setUserData] = useState<UserData[]>([]);
    const [buttonText, setButtonText] = useState('Add Hospital');
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [tableHeading, setTableHeading] = useState([
        {
            id: 1,
            title: t('hospital_list_table.hospital_name'),
        },
        {
            id: 2,
            title: t('hospital_list_table.hospital_email_id'),
        },
        {
            id: 3,
            title: t('hospital_list_table.hospital_contact_no'),
        },
        {
            id: 4,
            title: t('hospital_list_table.status'),
        },
        {
            id: 5,
            title: t('hospital_list_table.action'),
        },
        // Add more user objects here
    ]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await hospitalUserList();
                setUserData(data);
            } catch (error: any) {
                let errorMessage;
                switch (error.name) {
                    case 'ResourceNotFoundException':
                        errorMessage = 'Table or item not found.';
                        break;
                    case 'TooManyRequestsException':
                        errorMessage =
                            'Too many requests. Please try again later.';
                        break;
                    case 'ProvisionedThroughputExceededException':
                        errorMessage =
                            'Request limit exceeded. Please try again later.';
                        break;
                    case 'ServiceException':
                        errorMessage = `Service error: ${error.message}`;
                        break;
                    default:
                        errorMessage = `Unexpected error: ${error.message}`;
                        break;
                }
                MySwal.fire({
                    position: 'top-end', // Position the toast in the top-right corner
                    icon: 'error',
                    title: errorMessage,
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true,
                    customClass: {
                        popup: '!text-red !bg-light_red', // Add custom class to the popup
                    },
                    width: 'auto',
                });
            } finally {
                setLoading(false);
            }
        };

        fetchData();
        handleFetchCountries();
        const updateButtonText = () => {
            const pathname = location.pathname;
            if (pathname == INDIVIDUAL_USER_PATH) {
                setButtonText('Add Individual');
            } else if (pathname == HOSPITAL_USER_PATH) {
                setButtonText('Add Hospital');
            } else if (pathname == NURSE_USER_PATH) {
                setButtonText('Add Nurse');
            }
        };
        updateButtonText();
    }, []);

    const handleFetchCountries = async () => {
        const list = await fetchCountries();
        if (list.countries) {
            dispatch(setCountryList(list.countries));
        } else if (list.error) {
            // Handle error message
            console.error('Error fetching countries:', list.error);
        }
    };

    function selectChoice(choice: string) {
        setSelectedChoice(choice);
        // dispatch(setUserRole(choice));
    }

    function nextPage() {
        // if (selectedChoice == NURSE) {
        //     dispatch(setUserRole(NURSE));
        //     dispatch(setAdminCreateNurse(true));
        // } else if (selectedChoice == HOSPITAL) {
        dispatch(setUserRole(HOSPITAL));
        dispatch(setAdminCreateHospital(true));
        // }
        dispatch(setDeviceUniqueID(''));
        dispatch(setHospitalName(''));
        dispatch(setHospitalBranch(''));
        dispatch(setHospitalID(''));
        dispatch(setAddressOne(''));
        dispatch(setAddressTwo(''));
        dispatch(setCity(''));
        dispatch(setUserState(''));
        dispatch(setCountry(''));
        dispatch(setPincode(''));
        dispatch(setHospitalWebsite(''));
        dispatch(setHospitalEmail(''));
        dispatch(setHospitalContact(''));
        dispatch(setHospitalGST(''));
        dispatch(
            setFileMetadata({
                name: '',
                url: '',
                type: '',
            })
        );
        dispatch(setName(''));
        dispatch(setEmail(''));
        dispatch(setMobileNumber(''));
        dispatch(setPassword(''));
        dispatch(setShowUpdatePassword(true));
        navigate(CREATE_HOSPITAL_USER_PATH);
    }

    const handleModalButton = () => {
        navigate(CREATE_HOSPITAL_USER_PATH);
    };
    const handelAddUser = () => {
        // setShowModal(true);
        dispatch(setUserRole(HOSPITAL));
        dispatch(setDeviceUniqueID(''));
        dispatch(setHospitalName(''));
        dispatch(setHospitalBranch(''));
        dispatch(setHospitalID(''));
        dispatch(setAddressOne(''));
        dispatch(setAddressTwo(''));
        dispatch(setCity(''));
        dispatch(setUserState(''));
        dispatch(setCountry(''));
        dispatch(setPincode(''));
        dispatch(setHospitalWebsite(''));
        dispatch(setHospitalEmail(''));
        dispatch(setHospitalContact(''));
        dispatch(setHospitalGST(''));
        dispatch(
            setFileMetadata({
                name: '',
                url: '',
                type: '',
            })
        );
        dispatch(setName(''));
        dispatch(setEmail(''));
        dispatch(setMobileNumber(''));
        dispatch(setPassword(''));
        dispatch(setAdminCreateHospital(true));
        dispatch(setShowUpdatePassword(true));
        navigate(CREATE_HOSPITAL_USER_PATH);
    };
    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };

    const handleSortChange = (event: string) => {
        setSortField(event);
    };

    const handlePageChange = (newPage: number) => {
        setCurrentPage(newPage);
    };

    const handleRowsPerPageChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setRowsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page
    };

    const filteredUsers = useMemo(() => {
        let filtered = userData;
        if (searchTerm) {
            filtered = filtered.filter(
                (user) =>
                    user.hospitalName
                        ?.toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                    user.hospitalContact
                        ?.toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                    user.hospitalEmail
                        ?.toLowerCase()
                        .includes(searchTerm.toLowerCase())
            );
        }
        if (filterField) {
            // filtered = filtered.filter((user) =>
            //     user.status?.toLowerCase().includes(filterField.toLowerCase())
            // );
            if (filterField.toLowerCase() == 'all') {
                filtered;
            } else {
                filtered = filtered.filter((user) =>
                    user.status
                        ?.toLowerCase()
                        .includes(filterField.toLowerCase())
                );
            }
        }

        return filtered;
    }, [userData, searchTerm, filterField]);

    const sortedData = useMemo(() => {
        let sorted = [...filteredUsers];

        if (sortField !== undefined && sortField !== null) {
            sorted.sort((a: any, b: any) => {
                const dateA = new Date(a.createdAt_time);
                const dateB = new Date(b.createdAt_time);

                if (!isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) {
                    if (sortField.toLowerCase() === 'newest') {
                        return dateB.getTime() - dateA.getTime();
                    } else if (sortField.toLowerCase() === 'oldest') {
                        return dateA.getTime() - dateB.getTime();
                    }
                }

                // Handle cases where one or both dates are invalid
                if (isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) {
                    return sortField.toLowerCase() === 'newest' ? 1 : -1; // Treat invalid dateA as older/newer
                }
                if (!isNaN(dateA.getTime()) && isNaN(dateB.getTime())) {
                    return sortField.toLowerCase() === 'newest' ? -1 : 1; // Treat invalid dateB as older/newer
                }

                return 0;
            });
        }

        return sorted;
    }, [filteredUsers, sortField]);

    const paginatedUsers = useMemo(() => {
        const startIndex = (currentPage - 1) * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        return sortedData.slice(startIndex, endIndex);
    }, [sortedData, currentPage, rowsPerPage]);

    // const paginatedUsers = useMemo(() => {
    //     const startIndex = (currentPage - 1) * rowsPerPage;
    //     const endIndex = startIndex + rowsPerPage;
    //     return filteredUsers.slice(startIndex, endIndex);
    // }, [filteredUsers, currentPage, rowsPerPage]);

    const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
    const hasPaginatedUsers = paginatedUsers.length > 0;

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const maxVisiblePages = 3;

        if (totalPages <= 6) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(renderPageButton(i));
            }
        } else {
            if (currentPage <= maxVisiblePages) {
                // Case: currentPage is within the first 'maxVisiblePages'
                for (let i = 1; i <= maxVisiblePages + 1; i++) {
                    pageNumbers.push(renderPageButton(i));
                }
                pageNumbers.push(renderEllipsis());
                pageNumbers.push(renderPageButton(totalPages));
            } else if (currentPage >= totalPages - maxVisiblePages + 1) {
                // Case: currentPage is near the end
                pageNumbers.push(renderPageButton(1));
                pageNumbers.push(renderEllipsis());
                for (
                    let i = totalPages - maxVisiblePages + 1;
                    i <= totalPages;
                    i++
                ) {
                    pageNumbers.push(renderPageButton(i));
                }
            } else {
                // Case: currentPage is somewhere in the middle
                pageNumbers.push(renderPageButton(1));
                pageNumbers.push(renderEllipsis());

                const startPage = currentPage - 1;
                const endPage = currentPage + 1;

                for (let i = startPage; i <= endPage; i++) {
                    pageNumbers.push(renderPageButton(i));
                }

                pageNumbers.push(renderEllipsis());
                pageNumbers.push(renderPageButton(totalPages));
            }
        }

        return pageNumbers;
    };

    const renderPageButton = (pageNumber: any) => {
        return (
            <button
                key={pageNumber}
                className={`mx-1 pagination-padding py-2 border rounded ${pageNumber === currentPage ? '!bg-primary text-white' : 'bg-white text-black'}`}
                onClick={() => handlePageChange(pageNumber)}
            >
                {pageNumber}
            </button>
        );
    };

    const renderEllipsis = () => {
        return (
            <span
                key="ellipsis"
                className="bg-white pagination-padding py-2 border rounded"
            >
                ...
            </span>
        );
    };

    const handleFilterChange = (value: string) => {
        setFilterField(value);
        // setStatusFilter(value);
    };

    return (
        <>
            <div className="2xl:min-w-full xl:min-w-[1030px] lg:min-w-[745px]  mx-auto">
                {/* <div className="mx-auto mt-1"> */}
                <div className="d-flex justify-content-between align-items-center">
                    <h1 className="text-lg font-semibold">
                        {t('user_management.hospital_user.title')}
                    </h1>
                    <button
                        className="bg-primary rounded ml-4 py-2 btn px-3 text-white mr-3"
                        onClick={handelAddUser}
                    >
                        {buttonText}
                    </button>
                </div>
                {showModal && (
                    <div className="fixed inset-0 flex items-center justify-center z-50 bg-gray-800 bg-opacity-75">
                        <div className="bg-white p-6 rounded shadow-lg 2xl:w-[374px] lg:w-1/3 text-center relative">
                            <div className="my-2">
                                <button
                                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                                    onClick={handleCloseModal}
                                    aria-label="Close"
                                >
                                    <CloseIcon />
                                </button>
                            </div>
                            <h2 className="text-xl font-semibold mb-4">
                                {t('hospital_list_table.choose_hospital_user')}
                            </h2>
                            <div className="mb-2 flex items-center justify-center ">
                                <button
                                    className={`text-primary bg-white  rounded py-2 px-2 border-2 text-white mb-3 w-[279px] flex items-center justify-center  ${selectedChoice === NURSE ? 'border-primary hover:!bg-modal_button' : ''}`}
                                    onClick={() => selectChoice(NURSE)}
                                >
                                    <img
                                        src={ADD_USER_NURSWE_SRC}
                                        alt="Nurse"
                                        className="flex self-start"
                                    />
                                    <span className="flex-1 mr-12 font-bold">
                                        {t('hospital_list_table.nurse')}
                                    </span>
                                </button>
                            </div>
                            <div className="mb-2 flex items-center justify-center">
                                <button
                                    className={`text-primary bg-white rounded py-2 px-2  border-2  mb-3 w-[279px] flex items-center justify-center ${selectedChoice === HOSPITAL ? 'border-width-3 border-primary hover:!bg-modal_button' : ''}`}
                                    onClick={() => selectChoice(HOSPITAL)}
                                >
                                    <img
                                        src={ADD_USER_HOSPITAL_SRC}
                                        alt="Hospital"
                                        className="flex self-start"
                                    />
                                    <span className="flex-1 mr-12 font-bold">
                                        {t('hospital_list_table.hospital')}
                                    </span>
                                </button>
                            </div>
                            <div className="mt-4 items-center justify-center">
                                <button
                                    className="bg-primary text-white py-2 px-5 rounded"
                                    onClick={() => nextPage()}
                                >
                                    {t('hospital_list_table.next')}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                <div
                    className="d-flex justify-content-between my-4
                 align-items-center"
                >
                    <SearchBar
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                    />
                    <Dropdown className="mr-4">
                        <Dropdown.Toggle
                            as={CustomDropdownToggle}
                            variant="primary"
                            id="dropdown-basic"
                        >
                            {t('user_management.hospital_user.filter')}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Header>
                                {t('user_management.hospital_user.order')}
                            </Dropdown.Header>
                            <Dropdown.Item
                                className="flex items-center"
                                onClick={() => handleSortChange('newest')}
                            >
                                <input
                                    type="radio"
                                    name="newest"
                                    value="newest"
                                    aria-label="newest"
                                    checked={
                                        sortField.toLowerCase() == 'newest'
                                    }
                                    className="mr-2"
                                    readOnly
                                />
                                {t('user_management.hospital_user.newest')}
                            </Dropdown.Item>
                            <Dropdown.Item
                                className="flex items-center"
                                onClick={() => handleSortChange('oldest')}
                            >
                                <input
                                    type="radio"
                                    name="oldest"
                                    value="oldest"
                                    aria-label="oldest"
                                    checked={
                                        sortField.toLowerCase() == 'oldest'
                                    }
                                    className="mr-2"
                                    readOnly
                                />
                                {t('user_management.hospital_user.oldest')}
                            </Dropdown.Item>
                            <Dropdown.Header>
                                {t('user_management.hospital_user.status')}
                            </Dropdown.Header>
                            <Dropdown.Item
                                className="flex items-center"
                                onClick={() => handleFilterChange('all')}
                            >
                                <input
                                    type="radio"
                                    name="all"
                                    value="all"
                                    aria-label="all"
                                    checked={filterField.toLowerCase() == 'all'}
                                    className="mr-2"
                                    readOnly
                                />
                                {t('user_management.hospital_user.all')}
                            </Dropdown.Item>
                            <Dropdown.Item
                                className="flex items-center"
                                onClick={() => handleFilterChange('Waiting')}
                            >
                                <input
                                    type="radio"
                                    name="waiting"
                                    value="waiting"
                                    aria-label="waiting"
                                    checked={filterField == 'Waiting'}
                                    className="mr-2"
                                    readOnly
                                />
                                {t('user_management.hospital_user.waiting')}
                            </Dropdown.Item>
                            <Dropdown.Item
                                className="flex items-center"
                                onClick={() => handleFilterChange('Approved')}
                            >
                                <input
                                    type="radio"
                                    name="approved"
                                    value="approved"
                                    aria-label="approved"
                                    checked={filterField === 'Approved'}
                                    className="mr-2"
                                    readOnly
                                />
                                {t('user_management.hospital_user.approved')}
                            </Dropdown.Item>
                            <Dropdown.Item
                                className="flex items-center"
                                onClick={() => handleFilterChange('Rejected')}
                            >
                                <input
                                    type="radio"
                                    name="rejected"
                                    value="rejected"
                                    aria-label="rejected"
                                    checked={filterField === 'Rejected'}
                                    className="mr-2"
                                    readOnly
                                />
                                {t('user_management.hospital_user.rejected')}
                            </Dropdown.Item>
                            <Dropdown.Item
                                className="flex items-center"
                                onClick={() => handleFilterChange('Blocked')}
                            >
                                <input
                                    type="radio"
                                    name="blocked"
                                    value="blocked"
                                    aria-label="blocked"
                                    checked={filterField === 'Blocked'}
                                    className="mr-2"
                                    readOnly
                                />
                                {t('user_management.hospital_user.blocked')}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                {/* <UserTable data={paginatedUsers} header={tableHeading} /> */}
                <UserTable
                    data={paginatedUsers.map(({ ...rest }) => rest)}
                    header={tableHeading} row={rowsPerPage}  totalData={userData}
                />
                {paginatedUsers.length > 0 && (
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        handlePageChange={setCurrentPage}
                        disablePrevious={!hasPaginatedUsers}
                        disableNext={!hasPaginatedUsers}
                    />
                )}
            </div>
            {loading && <DataLoader />}
        </>
    );
};

export default HospitalUserList;
